export default __webpack_public_path__ + "static/media/MishHeroImage.1a8d0064.png";